import { useJumboLayoutSidebar } from '@jumbo/hooks';
import { ExpandMore } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Grid,
  TextField,
  Typography
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { getArchiveSearchListApi } from 'api/meeting';
import 'dayjs/locale/tr';
import { useState } from 'react';

function ArchiveDataTableFilter({ setFilterData, setSelectedFilters, setLoading, setSearchType }) {
  const [filters, setFilters] = useState({
    meetingNo: "",
    pdateStart: null,
    pdateEnd: null
  });

  const { meetingNo, pdateStart, pdateEnd } = filters;
  const [expanded, setExpanded] = useState(false);
  const { setSidebarOptions } = useJumboLayoutSidebar();

  const handleInputChange = (field) => (event) => {
    setFilters((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const handleDateChange = (field) => (newValue) => {
    setFilters((prev) => ({ ...prev, [field]: newValue }));
  };

  const handleSearch = async () => {
    if (setSelectedFilters) {
      setSelectedFilters(filters);
    }
    setExpanded(false);
    try {
      setLoading(true);
      const res = await getArchiveSearchListApi({
        meetingNo,
        pdateStart: pdateStart ? pdateStart.toISOString() : null,
        pdateEnd: pdateEnd ? pdateEnd.toISOString() : null
      });
      setFilterData(res.data);
      if (setSearchType) {
        setSearchType("filter");
      }
    } catch (error) {
      console.error("Error during search:", error);
    } finally {
      setSidebarOptions({ open: false });
      setLoading(false);
    }
  };

  const handleClear = () => {
    setFilters({
      meetingNo: "",
      pdateStart: null,
      pdateEnd: null
    });
    setFilterData([]);
    if (setSelectedFilters) {
      setSelectedFilters({});
    }
    if (setSearchType) {
      setSearchType(null);
    }
  };

  return (
    <Accordion
      expanded={expanded}
      onChange={(event, isExpanded) => setExpanded(isExpanded)}
      sx={{ background: "#e1e1e1" }}
    >
      <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel1a-content" id="panel1a-header">
        <Typography>Filtreler</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2} padding={1} sx={{ background: "#e1e1e1" }}>
          <Grid container item xs={12} spacing={2}>
            <Grid item xs={12} sm={3} lg={2}>
              <TextField
                id="meetingNo"
                label="Toplantı Sayı"
                value={meetingNo}
                onChange={handleInputChange("meetingNo")}
                fullWidth
                size="small"
              />
            </Grid>
            <Grid container item xs={4}>
              <Grid item xs={12} sm={12} lg={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="tr">
                  <DatePicker
                    label="Başlangıç Tarihi"
                    value={pdateStart}
                    onChange={handleDateChange("pdateStart")}
                    renderInput={(params) => <TextField size="small" sx={{ margin: '5px' }} {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={12} lg={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="tr">
                  <DatePicker
                    label="Bitiş Tarihi"
                    value={pdateEnd}
                    onChange={handleDateChange("pdateEnd")}
                    renderInput={(params) => <TextField size="small" sx={{ margin: '5px' }} {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} container justifyContent="flex-end" spacing={1}>
            <Grid item>
              <Button variant="contained" size="small" onClick={handleSearch}>
                Ara
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" size="small" onClick={handleClear}>
                Temizle
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}

export default ArchiveDataTableFilter;
